import { Sparkle } from "lucide-react";

// One slow editorial marquee. Duplicate content for a seamless loop.
export const Marquee = ({ items, dark = true, className = "" }) => (
  <div
    className={`select-none overflow-hidden border-y py-7 ${
      dark ? "border-white/10 bg-[#050D09]" : "border-[#07130C]/10 bg-white"
    } ${className}`}
    aria-hidden="true"
  >
    <div className="animate-marquee flex w-max">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center">
          {items.map((item, i) => (
            <span
              key={i}
              className={`mx-8 flex items-center gap-8 whitespace-nowrap font-display text-2xl font-medium tracking-tight md:text-4xl ${
                dark ? "text-white/25" : "text-[#07130C]/20"
              }`}
            >
              {item}
              <Sparkle className="h-4 w-4 text-[#D3B74D]/70" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
